import React from 'react';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay';
import dayjs from 'dayjs';
import { getFDIColor } from '../../utils/fdiColor';

interface FDICalendarDayProps extends PickersDayProps<dayjs.Dayjs> {
  fdiByDate?: Record<string, number>;
}

const FDICalendarDay: React.FC<FDICalendarDayProps> = ({ fdiByDate, ...other }) => {
  const dateKey = other.day.format('YYYY-MM-DD');
  const fdi = fdiByDate?.[dateKey];
  const hasFDI = fdi !== undefined && fdi !== null;

  return (
    <PickersDay
      {...other}
      sx={{
        ...((other.sx as object) || {}),
        ...(hasFDI && !other.outsideCurrentMonth
          ? {
              backgroundColor: getFDIColor(fdi),
              borderRadius: '50%',
              color: '#fff',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: getFDIColor(fdi, 0.7),
              },
              '&.Mui-selected': {
                backgroundColor: getFDIColor(fdi, 0.85),
                '&:hover': {
                  backgroundColor: getFDIColor(fdi, 0.95),
                },
              },
            }
          : {}),
      }}
    />
  );
};

export default FDICalendarDay;
